<template>
   <!--产地价格-->
   <div id='originPrice' class='origin_price_container'></div>
</template>
<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/pie'
import { option as pricelineOption } from '@/sxhlgChartsConfig/originPriceOption.js' // 配置项
// import {option as dataResponse} from '@/sxhlgChartsConfig/provideData.js' //临时数据
import { filterArr } from '@/utils/dataFilter.js' // 数组空值转换

export default{

  data () {
    return {
      xAxisData: [],
      dataLastYearStore: [],
      dataCurrentYearStore: [],
      showCount: 12, // 显示的数据数量
      showIndexPre: 0,
      showIndexLast: 15
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/suixi/origin_price').then(res => {
        this.dataResponse = res.data
        // 线数据
        //  "min_price":[],
        //  "max_price":[], 当日最高价
        //  "avg_price":[],当日平均价格
        this.dataLastYearStore = filterArr(this.dataResponse.data.last_year_price)
        this.dataCurrentYearStore = filterArr(this.dataResponse.data.current_year_price)
        // x轴数据
        this.xAxisDataStore = this.dataResponse.data.date.map(item => {
          return `${item.substring(0, 2)} / ${item.substring(2, 4)}`
        })
        // 数据总数
        this.countAll = this.dataResponse.data.date.length
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    initOption (data) {
      // 显示全部时 设置显示的间隔
      pricelineOption.xAxis[0].axisLabel.interval = Math.floor(this.dataLastYearStore.length / this.showCount) - 1

      // this.dataLastYear=this.dataLastYearStore.slice(0,this.showCount);
      // this.dataLastYear=this.dataLastYearStore.slice(0,this.showCount);
      // this.dataCurrentYear=this.dataCurrentYearStore.slice(0,this.showCount);

      this.dataLastYear = this.dataLastYearStore.slice(0, this.dataLastYearStore.length)
      this.dataCurrentYear = this.dataCurrentYearStore.slice(0, this.dataLastYearStore.length)
      this.xAxisData = this.xAxisDataStore.slice(0, this.showCount)
      // x轴数据
      pricelineOption.xAxis[0].data = this.xAxisData
      // 线数据
      pricelineOption.series = [{
        name: '去年价格',
        type: 'line',
        data: this.dataLastYear,
        smooth: true
      },
      {
        name: '今年价格',
        type: 'line',
        data: this.dataCurrentYear,
        smooth: true
      }
      ]

      this.lineChart.setOption(pricelineOption)
    },
    // 间隔一定数量获取数组数据
    getPartData () {

    }
  },
  mounted () {
    this.lineChart = echarts.init(document.getElementById('originPrice'))

    // 改变数据设置动效
    var that = this
    let changeLinePoint = () => {
      if (that.showIndexLast >= that.countAll) {
        that.showIndexPre = -1
        that.showIndexLast = that.showCount - 1
      }

      // 显示全部的写法
      that.showIndexPre = 0
      that.showIndexLast = this.dataLastYearStore.length
      // that.showIndexPre+=5;
      // that.showIndexLast+=5;
      that.dataLastYear.length = 0
      that.dataLastYear.push(...that.dataLastYearStore.slice(that.showIndexPre, that.showIndexLast))
      that.dataCurrentYear.length = 0
      that.dataCurrentYear.push(...that.dataCurrentYearStore.slice(that.showIndexPre, that.showIndexLast))
      that.xAxisData.length = 0
      that.xAxisData.push(...that.xAxisDataStore.slice(that.showIndexPre, that.showIndexLast))
      that.lineChart.setOption(pricelineOption)
      setTimeout(() => {
        // changeLinePoint();  //暂时取消动态显示 同时设置显示数量为全部
      }, 2000)
    }

    // 初始化
    function init () {
      // 获取数据
      that.getData(() => {
        // 处理返回数据
        that.initOption(that.dataResponse)
        // 设置数据切换
        changeLinePoint()
      })
    }
    init()
    // 每天更新一次数据
    setInterval(() => {
      init()
    }, 24 * 60 * 60 * 1000)
  }
}

</script>
<style lang='less' scoped>

  .origin_price_container{
    width: 100%;
    height:100%;
    background:none;
    padding:10px;
  }
</style>
